<template lang="pug">
div
  #modal-promo01.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-dialog-scrollable
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo1.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img(src='assets/img/promo/deposit.jpg')
          promoContent(:target="1")
  #modal-promo02.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo2.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/pin.jpg")
          promoContent(:target="2")
  #modal-promo03.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo3.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body.no-padding
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/welcome.jpg")
          promoContent(:target="3")
  #modal-promo04.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo4.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/topup.jpg")
          promoContent(:target="4")
  #modal-promo05.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo5.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/weekend.jpg")
          promoContent(:target="5")
  #modal-promo06.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo6.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/attendance.jpg")
          promoContent(:target="6")
  #modal-promo07.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo7.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/referral.jpg")
          promoContent(:target="7")
  #modal-promo08.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo8.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/15weekend.jpg")
          promoContent(:target="8")
  #modal-promo09.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo9.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/520.jpg")
          promoContent(:target="9")
  #modal-promo10.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo10.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/birthday.jpg")
          promoContent(:target="10")
  #modal-promo11.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo11.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/casinowelcome.jpg")
          promoContent(:target="11")
  #modal-promo12.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo12.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/casino15.jpg")
          promoContent(:target="12")
  #modal-promo13.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo13.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/casinoweekend.jpg")
          promoContent(:target="13")
  #modal-promo14.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo14.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/1111.jpg")
          promoContent(:target="14")
  #modal-promo15.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo15.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/comeback50.jpg")
          promoContent(:target="15")
  #modal-promo16.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo16.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/olympic500.jpg")
          promoContent(:target="16")
  #modal-promo17.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-lg.modal-dialog-centered.modal-full.modal-promo(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{$tc('ui.promo_detail.promo17.title')}}
          button.btn-close(type='button' data-bs-dismiss='modal' aria-label='Close')
        .modal-body
          .text-center
            img.w-100.img-fluid(src="assets/img/promo/olympic33.jpg")
          promoContent(:target="17")
</template>
<script>
import promoContent from '@/components2/promotionTable/_promoContent.vue'
export default {
  components:{
    promoContent
  },
  mounted(){
    
  }
};
</script>
<style lang="scss" scoped>
.no-padding{
  @media(max-width: 681px){
    padding: 0 !important;
  }
}
.mobile-margin{
  @media(max-width: 681px){
    margin: 0 !important;
  }
}
</style>
